import React, { useEffect } from 'react'
import { Table } from '../../../components/ui/Table'
import { axiosGet } from '../../../util/api'
import { LoadFunc, useTableHooks } from '../../../packages/blueprint-components/src/useTableHooks'
import { useRecoilValue } from 'recoil'
import { useLastDayAtom } from './admin_updates_state'
import { Link } from 'react-router-dom'
import Update = Models.Update
import { Column } from '../../../types/table'

export const MostFailedByProfileTable = () => {
    const useToday = useRecoilValue(useLastDayAtom)

    const load: LoadFunc<Update> = (params: any) => {
        return axiosGet('admin/most-failed-by-profile', params)
    }

    const tableHooks = useTableHooks((params: any) => {
        params.use_today = useToday
        return load(params)
    })

    useEffect(() => {
        tableHooks.reload()
    }, [useToday])

    const columns: Column<Update, any>[] = [
        {
            key: 'cnt',
            title: 'Count',
        },
        {
            key: 'profile_id',
            cell: ({ profile_id }) => (
                <Link to={`/admin/profiles/${profile_id}`}>{profile_id}</Link>
            ),
        },
    ]

    return (
        <Table
            name="Most Failed By Profile"
            showHeader
            className=""
            filters={null}
            canSelect={false}
            columnSelection={false}
            columns={columns}
            tableHooks={tableHooks}
            onSelectChange={null}
            stickyFooter={false}
            height={400}
        />
    )
}
